import 'css-chunksrc/client/scenes/documentRemoval/styles.scss';export default {
  "header": "_header_7ieux_1",
  "group": "_group_7ieux_5",
  "text": "_text_7ieux_9",
  "name": "_name_7ieux_14",
  "main": "_main_7ieux_20",
  "buttons": "_buttons_7ieux_27"
};